module.exports = __webpack_public_path__ + "oops.75ad5e136af232fe863b.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/assets/img/jpeg/oops.jpg
// module id = ../../../../../src/assets/img/jpeg/oops.jpg
// module chunks = 0